<template>
  <div class="sort">
    <i class="fas fa-sort-amount-up"></i>
    <a
      href="#"
      v-for="(name, key) in sortTypes"
      :key="key"
      class="sort-by-link"
      @click.prevent="$parent.sort(key)"
      :class="{ active: $parent.sortBy === key }"
    >
      <span>{{ $parent.direction }}</span>{{ name }}
    </a>
  </div>
</template>

<script>
export default {
  props: ['sortTypes']
}
</script>

<style lang="scss" scoped>
.sort {
  display: flex;
  justify-content: center;
  align-items: center;
}
.sort-by-link {
  color: #999999;
  margin-left: 10px;
  font-size: 13px;
  text-transform: uppercase;
  & span {
    display: none;
  }

  &:hover {
    text-decoration: underline;
  }

  &.active {
    font-weight: bold;

    & span {
      display: inline;
      margin-right: 3px;
    }
  }
}
</style>